export interface R18ImageVisibilityOptions {
  hasAttachment: boolean;
  isR18Thread: boolean;
  showR18: boolean;
  revealed: boolean;
}

export function isR18ImageHidden(options: R18ImageVisibilityOptions): boolean {
  return (
    options.hasAttachment &&
    options.isR18Thread &&
    !options.showR18 &&
    !options.revealed
  );
}
